import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=bab1ea84&"
import script from "./NewPassword.vue?vue&type=script&lang=js&"
export * from "./NewPassword.vue?vue&type=script&lang=js&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=bab1ea84&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bab1ea84')) {
      api.createRecord('bab1ea84', component.options)
    } else {
      api.reload('bab1ea84', component.options)
    }
    module.hot.accept("./NewPassword.vue?vue&type=template&id=bab1ea84&", function () {
      api.rerender('bab1ea84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/NewPassword.vue"
export default component.exports